﻿import { Dialog, Notify, Loading, QSpinnerGears } from 'quasar'
import alert from '@/common/dialogs/alert.vue';
import confirmation from '@/common/dialogs/confirmation.vue';
import prompt from '@/common/dialogs/prompt.vue';
import exception from '@/common/dialogs/exception.vue';
import validation from '@/common/dialogs/validation.vue';

class Dialogs {
    Alert(title, message, icon) {
        return Dialog.create({
            component: alert,
            componentProps: {
                title: title,
                message: message,
                icon: icon,
                persistent: true
            },
        });
    }

    Confirm(title, message, icon) {
        return Dialog.create({
            component: confirmation,
            componentProps: {
                title: title,
                message: message,
                icon: icon || 'delete',
                size: 'sm',
                persistent: true
            },
        });
    }

    Prompt(title, message, input, size, icon) {
        return Dialog.create({
            component: prompt,
            componentProps: {
                title: title,
                message: message,
                input: input,
                icon: icon || 'keyboard',
                size: size
            },
        });
    }

    Open(component, props) {
        return Dialog.create({
            component: component,
            componentProps: props
        });
    }

    Error(err) {
        if (err === 0) return;

        let e = err.data || err;
        return Dialog.create({
            component: err.status == 400 ? validation : exception,
            componentProps: {
                data: e,
            }
        });
    }

    Validation(errors) {
        return Dialog.create({
            component: validation,
            componentProps: {
                data: errors,
            }
        });
    }

    async Loading(callback, notifyText) {
        Loading.show({
            spinner: QSpinnerGears
        });

        try {
            await callback();
        } catch (e) {
            this.Error(e);
        }

        if (notifyText) this.Notify(notifyText);

        Loading.hide();
    }

    Notify(msg, icon) {
        Notify.create({
            message: msg,
            color: 'accent',
            textColor: 'white',
            icon: icon || 'info',
            iconColor: 'white',
            position: 'top',
            timeout: 3000
        });
    }
}

export default new Dialogs();